import React from 'react'
import { useTranslation } from 'react-i18next'
import "./KoFi.css"

const KoFi = () => {
    const { t } = useTranslation()
    return (
        <div className="support">
            <div className="kofi">
                <div className="title">{t('kofi__support')}</div>
                <div className="title"><b>KO-Fi</b></div>
                <div className="text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</div>
                <div className="button">{t('kofi__button')} ☕</div>
            </div>
            <div className="social__previous_version">
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
                <br /><br />
                view previous <a href="v6.ronnie.tech">version</a> of this portfolio.

            </div>
        </div>
    )}

export default KoFi
